import axios from "axios";
import adminApi from "../axios";
import { v1BaseUrl } from "./apiBaseUrl";

const tokenConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("@token")}` } });
const v1Api = axios.create({ baseURL: v1BaseUrl });

export async function listClasses(params = {}) {
  const response = await adminApi.get("classes", { ...tokenConfig(), params });
  return Array.isArray(response.data) ? response.data : response.data?.data || [];
}

export async function getClassDetails(classId) {
  const response = await adminApi.get(`classes/${classId}`, tokenConfig());
  return response.data?.data || response.data;
}

export async function createAvailability(payload) {
  const response = await v1Api.post("classes/availability", payload, tokenConfig());
  return response.data?.data || response.data;
}

export async function updateAvailability(ruleId, payload) {
  const response = await v1Api.put(`classes/availability/${ruleId}`, payload, tokenConfig());
  return response.data?.data || response.data;
}

export async function deleteAvailability(ruleId) {
  const response = await v1Api.delete(`classes/availability/${ruleId}`, tokenConfig());
  return response.data?.data || response.data;
}

export async function getGuruAvailability(guruId, params = {}) {
  const response = await v1Api.get(`classes/availability/${guruId}`, { ...tokenConfig(), params });
  return response.status === 204 ? [] : response.data?.data || response.data || [];
}

export async function reassignClassGuru(classId, newGuruId, reason) {
  const response = await adminApi.patch(`classes/${classId}/guru`, { new_guru_id: Number(newGuruId), reason }, tokenConfig());
  return response.data?.data || response.data;
}

export async function cancelClass(classId) {
  const response = await v1Api.put(`classes/cancel/${classId}`, {}, tokenConfig());
  return response.data?.data || response.data;
}

export async function cancelBooking(classId, studentId) {
  const response = await v1Api.put(`classes/${classId}/bookings/${studentId}/cancel`, {}, tokenConfig());
  return response.data?.data || response.data;
}

export async function markAttendance(classId, studentId, attendanceStatus) {
  const response = await v1Api.patch(`classes/${classId}/students/${studentId}/attendance`, { attendance_status: attendanceStatus }, tokenConfig());
  return response.data?.data || response.data;
}

export async function bulkBook(payload) {
  const response = await v1Api.post("classes/book", payload, tokenConfig());
  return response.data?.data || response.data;
}
